import { CurrencyInfo } from '@app/models/currency-info';
import { createAction, props } from '@ngrx/store';

export const setAll = createAction('[Currencies] Set All Currencies', props<{ currencies: CurrencyInfo[] }>());
export const selectCurrency = createAction('[Currencies] selectCurrency', props<{ selected: CurrencyInfo }>());
